import React from 'react';
import './Awards.css';

const SideBySideDivs = () => {
    return (
        <div className="awards">
            <div className="left-div">
                <div className='award-head'>
                    <div className='line'></div>
                    <h2 className='award-title'>&nbsp;&nbsp;Awards<span className='dot'>.</span></h2>
                </div>
                <div className='scroll'>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>Valedictorian</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Award</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Voted as the Valedictorian of Batch 2024</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>1st Place at Hackanova</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Hackathon</h3>
                            <a className='read-btn'>TCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Crowned victorious in an AI hackathon at Thakur College of Engineering.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>1st Place at Hackerstellar</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Hackathon</h3>
                            <a className='read-btn'>KJSCE, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Emerged victorious in an AI/ML hackathon at K J Somaiya College of Engineering.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>1st Place at Business Presentation</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Competition</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Achieved first place in a business presentation competition by pitching Epilepsyshield.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>Top 5 Finalist at Code-o-Fiesta</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Hackathon</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Secured a position as one of the top five finalists in Code-o-Fiesta, a web development competition at CodeUOUEiesta U.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>Achiever of the Year (2022-2023)</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Award</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Named Achiever of the Year (2022-2023) in the computer department, surpassing 200+ students.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>122/4898 in Amazon's ML Challenge</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Online Hackathon</h3>
                            <a className='read-btn'>HackerEarth</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Ranked 122nd out of 4898 participants in Amazon's ML Challenge.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>2x Winner at VCET's National Project Showcase</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Competition</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Secured two victories at VCET's National Project Showcase—one for EpilepsyShield and another for an emotion-based music recommending chatbot.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='a-title'>2nd Place at Oscillation Paper Presentation</h2>
                        </div>
                        <div className='a-type'>
                            <h3 className='type'>Competition</h3>
                            <a className='read-btn'>VCET, Mumbai</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Secured the 2nd place at the Oscillation Paper Presentation with a paper focusing on emotion-based music recommendation.</p>
                        </div>
                    </div>

                </div>
            </div>
            <div className="right-div">
                <div className='pub-head'>
                    <div className='line'></div>
                    <h2 className='pub-title'>&nbsp;&nbsp;Publications<span className='dot'>.</span></h2>
                </div>
                <div className='scroll'>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='p-title'>Detection of Flashy Segment in YouTube Videos using Computer Vision Technique to Prevent Seizure in Epilepsy Patients</h2>
                        </div>
                        <div className='p-type'>
                            <h3 className='type'>Research Paper</h3>
                            <a href="https://ieeexplore.ieee.org/document/10192767" className='read-btn'>Read</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Proposing a browser extension with OpenCV to warn against seizure-inducing content in YouTube videos for those with photosensitive epilepsy.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='p-title'>Intelligent Waste Material Classification Using EfficientNet- B3 Convolutional Neural Network for Enhanced Waste Management</h2>
                        </div>
                        <div className='p-type'>
                            <h3 className='type'>Research Paper</h3>
                            <a className='review-btn'>Under Review</a>
                        </div>
                        <div className='description'>
                            <p className='abstract'>Proposing an intelligent waste classification system using EfficientNet-B3 CNN to achieve 97% accuracy in categorizing urban waste, aiming to optimize and expedite waste separation for sustainable urban development.</p>
                        </div>
                    </div>
                    <div className='sep'></div>
                    <div className='paper'>
                        <div className='exp-n'>
                            <h2 className='p-title'>Mastering GPT-3: Fine-Tuning Techniques with the OpenAI API and Python</h2>
                        </div>
                        <div className='p-type'>
                            <h3 className='type'>Article</h3>
                            <a href='https://medium.com/@rishabhtripathi1/mastering-gpt-3-fine-tuning-techniques-with-the-openai-api-and-python-4c3a3eaef45d' className='readn-btn'>Read</a>
                        </div>
                    </div>
                    <div className='sep'></div>
                </div>
            </div>
        </div >
    );
};

export default SideBySideDivs;
